import { render } from "./subjectBindClass.vue?vue&type=template&id=6a4396d8&scoped=true"
import script from "./subjectBindClass.vue?vue&type=script&lang=js"
export * from "./subjectBindClass.vue?vue&type=script&lang=js"

import "./subjectBindClass.vue?vue&type=style&index=0&id=6a4396d8&lang=scss&scoped=true"

import exportComponent from "E:\\wwwroot\\qifu-web-v1.0.0\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a4396d8"]])

export default __exports__